import { useMutation } from '@tanstack/react-query';
import { Button, Card, TextInput } from 'flowbite-react';
import { CheckIcon } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';

import { useApi } from '../../../api/useApi.hook';
import { ProductLogo } from '../../components/productLogo/productLogo.component';
import { RouteIndex } from '../../routeIndex';

interface FormValues { email: string }

const ForgotPasswordView = () => {
    const api = useApi();
    const { register, handleSubmit, formState: { errors } } = useForm<FormValues>({
        defaultValues: { email: '' }
    });

    const doReset = useMutation({
        mutationFn: (email: string) => api.v1.auth.provider.password.resetRequest(email),
    });

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 p-2">
            <Card className="p-4 w-full max-w-sm shadow-lg">
                <ProductLogo className='text-center' />
                <div className='w-full border-t border-t-gray-200' />
                <h4 className="text-xl font-semibold text-center">Zapomenuté heslo</h4>

                {doReset.isSuccess ? (
                    <div className='flex flex-col items-center gap-3'>
                        <CheckIcon size={48} className='text-lime-700' />
                        <p className='text-center text-sm'>
                            Pokud účet s tímto e-mailem existuje, byl na něj odeslán odkaz pro reset hesla. Zkontrolujte také složku Spam.
                        </p>
                        <Link to={RouteIndex.login} className='text-sm text-blue-600 hover:underline'>
                            Zpět na přihlášení
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit((d) => doReset.mutate(d.email.trim()))} className='flex flex-col gap-4'>
                        <p className='text-sm text-gray-600'>
                            Zadejte váš e-mail a pošleme vám odkaz pro nastavení nového hesla.
                        </p>
                        <div>
                            <TextInput
                                id="email"
                                type="email"
                                placeholder="Váš e-mail"
                                {...register('email', { required: 'E-mail je povinný' })}
                                color={errors.email ? 'failure' : ''}
                            />
                            {errors.email && (
                                <p className="text-sm text-red-500 mt-1">{errors.email.message}</p>
                            )}
                        </div>

                        {doReset.isError && (
                            <p className='text-sm text-red-500 text-center'>Nastala chyba. Zkuste to znovu.</p>
                        )}

                        <Button type="submit" color="dark" className="w-full" disabled={doReset.isPending}>
                            {doReset.isPending ? 'Odesílám...' : 'Odeslat odkaz'}
                        </Button>

                        <Link to={RouteIndex.login} className='text-sm text-center text-blue-600 hover:underline'>
                            Zpět na přihlášení
                        </Link>
                    </form>
                )}
            </Card>
        </div>
    );
};

export default ForgotPasswordView;
